import React from 'react';
import BagelQuoteBlock from './BagelQuoteBlock';
import BagelDocPreviewBlock from './BagelDocPreviewBlock';

type FenceComponent = React.ComponentType<{ children: string }>;

const FENCE_MAP: Record<string, FenceComponent> = {
  quote: BagelQuoteBlock,
  'doc-preview': BagelDocPreviewBlock,
};

/**
 * fenceRouter — maps a fenced code block's language string to a rich React component.
 * Returns null for unknown languages (ReactMarkdown will render a plain <pre><code> block).
 *
 * To add a new response tool:
 *   1. Create a new component (e.g. BagelTimelineBlock.tsx)
 *   2. Add one line here: 'timeline': BagelTimelineBlock
 *   3. Update the bagel_chat_system prompt to document the new fence type
 */
export default function fenceRouter(
  language: string | undefined,
): FenceComponent | null {
  if (!language) return null;
  return FENCE_MAP[language] ?? null;
}
